import React from "react";
import styled from "styled-components";
import { bool, func, node, string } from "prop-types";

const TextAreaWrapper = styled.div`
  display: flex;
  flex-direction: ${({ verticalLayout }) =>
    verticalLayout ? "column" : "row"};
  align-items: center;
  justify-content: center;
`;

const StyledTextArea = styled.textarea`
  font-family: "Source Sans Pro", sans-serif;
  font-size: medium;
  outline: none;
  border-radius: 5px;
  resize: none;
  border: ${({ border }) => border};
  margin: ${({ margin }) => margin};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  padding: ${({ padding }) => padding};
`;

const StyledLabel = styled.label`
  margin: ${({ margin }) => margin};
`;

const Input = ({
  border = "none",
  height = "100px",
  id,
  label,
  labelMargin = "10px",
  margin = "10px",
  onBlur,
  onChange,
  padding = "10px",
  placeholder,
  width = "300px",
  value,
  verticalLayout
}) => (
  <TextAreaWrapper verticalLayout={verticalLayout}>
    {label && (
      <StyledLabel htmlFor={id} margin={labelMargin}>
        {label}
      </StyledLabel>
    )}
    <StyledTextArea
      border={border}
      id={id}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      margin={margin}
      width={width}
      height={height}
      padding={padding}
      value={value}
    />
  </TextAreaWrapper>
);

Input.propTypes = {
  border: string,
  height: string,
  id: string,
  label: string,
  labelMargin: string,
  margin: string,
  onBlur: func,
  onChange: func,
  padding: string,
  placeholder: string,
  width: string,
  value: node,
  verticalLayout: bool
};

export default Input;
